import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
    addData: ['data'],
    removeData: ['data'],
    selectItem: ['itemSelected']
});

const INITIAL_STATE = {
    data: [],
    itemSelected: null
};

const addData = (state) => {
    return ({...state, data: [...state.data]});
};

const removeData = (state, _data) => {
    return ({...state, data: _data.data});
};

const selectItem = (state, item) => {
    return ({...state, itemSelected: item});
}

export default createReducer(INITIAL_STATE, {
    [Types.ADD_DATA]: addData,
    [Types.REMOVE_DATA]: removeData,
    [Types.SELECT_ITEM]: selectItem
});